import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const TermsAndServices = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Términos y Condiciones
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          1. Datos Reales
        </Typography>
        <Typography>
          Los datos proporcionados por los usuarios deben ser reales y verídicos. Cualquier intento de proporcionar información falsa o engañosa será motivo de sanciones.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          2. Precios Especificados
        </Typography>
        <Typography>
          Los precios especificados en la plataforma deben ser los precios reales al comprador. Cualquier intento de atraer compradores con precios inverosímiles o distintos a los otorgados culminará en un bloqueo temporal o permanente del sitio, dependiendo de la gravedad de la infracción.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          3. Uso de la Plataforma
        </Typography>
        <Typography>
          Los usuarios se comprometen a utilizar la plataforma de manera responsable y a no realizar actividades que puedan perjudicar a otros usuarios o a la plataforma misma.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          4. Modificaciones a los Términos
        </Typography>
        <Typography>
          Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento. Los cambios serán efectivos una vez publicados en esta página.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          5. Aceptación de los Términos
        </Typography>
        <Typography>
          Al utilizar nuestra plataforma, usted acepta cumplir con estos términos y condiciones. Si no está de acuerdo con alguno de los términos, le pedimos que no utilice la plataforma.
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          6. Contacto
        </Typography>
        <Typography>
          Si tiene alguna pregunta sobre estos términos, no dude en contactarnos a través de nuestro formulario de contacto.
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsAndServices; 